import axios from "axios";
import React from "react";

interface IGender {
  id: number;
  name: string;
}

export default function useGenders(): [Map<number, string>, boolean] {
  const [genders, setGenders] = React.useState<Map<number, string>>(new Map());
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<IGender[]>("/gender/")
      .then((response) => {
        setGenders(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => { console.error(error); setLoading(false); });
  }, []);

  return [genders, loading];
}
